export const languageSchema = {
  type: "object",
  properties: {
    language: {
      type: "string",
      pattern: "^[a-z]{2}$",
    },
  },
};

export const addLanguageSchema = {
  body: {
    type: "object",
    properties: {
      code: {
        type: "string",
        pattern: "^[a-z]{2}$",
      },
      name: { type: "string", minLength: 1 },
      nativeName: { type: "string", minLength: 1 },
    },
    required: ["code", "name"],
    additionalProperties: false,
  },
};

export const updateLanguageSchema = {
  body: {
    type: "object",
    properties: {
      code: {
        type: "string",
        pattern: "^[a-z]{2}$",
      },
      name: { type: "string", minLength: 1 },
      nativeName: { type: "string", minLength: 1 },
      isActive: { type: "boolean" },
      isDefault: { type: "boolean" },
    },
    required: ["code", "name", "isActive", "isDefault"],
  },
};

export const web_addLanguageSchema = {
  type: "object",
  properties: {
    code: {
      type: "string",
      pattern: "^[a-z]{2}$",
    },
    name: { type: "string", minLength: 1 },
    nativeName: { type: "string", minLength: 1 },
  },
};

export const deleteLanguageSchema = {
  body: {
    type: "object",
    properties: {
      code: {
        type: "string",
        pattern: "^[a-z]{2}$",
      },
    },
    required: ["code"],
  },
};
